import { Button } from '@sparemin/blockhead';
import IconModal from 'components/IconModal';
import { useNotification } from 'components/Notification';
import useSubmitPodcastOwnershipClaim from 'pages/Play/state/useSubmitPodcastOwnershipClaim';
import React from 'react';
import { useConnectedModal, useModalControls } from 'state/modals';

type ClaimPodcastOwnershipModalProps = {};

const ClaimPodcastOwnershipModal: React.FC<
  ClaimPodcastOwnershipModalProps
> = () => {
  const name = 'ClaimPodcastOwnership';
  const { params } = useConnectedModal({ name });
  const { podcastId } = params ?? {};

  const { showError, showSuccess } = useNotification();
  const { close } = useModalControls();
  const { mutate: initiatePodcastClaim, isLoading } =
    useSubmitPodcastOwnershipClaim();

  const handlePress = () => {
    initiatePodcastClaim(podcastId, {
      onSuccess: () => {
        close();
        showSuccess("We've emailed the address in this feed!");
      },
      onError: () => {
        showError('Something went wrong. Please try again.');
      },
    });
  };

  return (
    <IconModal
      title="Claim your podcast"
      subtitle="Your email address doesn’t match the one in the RSS feed, but you can request access from that email address. We’ll send a verification request there if you’d like!"
      modalName={name}
    >
      <Button onPress={handlePress} fluid disabled={isLoading}>
        send verification email
      </Button>
      <Button onPress={close} variant="ghost" fluid>
        no thanks
      </Button>
    </IconModal>
  );
};
export default ClaimPodcastOwnershipModal;
